module.exports = __webpack_public_path__ + "img/SenryuCoverArt.b6f1fa65.png";